/**
 * UranIA PA — `/admin/compliance` (redirect a `/admin/conformita`).
 *
 * Fusioni A.4.4/A.4.5 (Riordino della mappa delle rotte §4): il
 * contenuto vive ora su `/admin/conformita` (`routes/admin/conformita/index.tsx`).
 * Questa rotta resta solo come redirect.
 */

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as AmministrazioneSegmentRoute } from '../../_amministrazione.tsx';

export const Route = createRoute({
  getParentRoute: () => AmministrazioneSegmentRoute,
  path: '/admin/compliance',
  beforeLoad: () => {
    throw redirect({ to: '/admin/conformita', replace: true });
  },
});
